
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const Sidebar = () => {
  const [isFormsOpen, setIsFormsOpen] = useState(false);
  const [isContentOpen, setIsContentOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    navigate('/admin/login');
  };

  return (
    <div className="w-64 bg-gradient-to-tr from-[#264864] via-[#264864] to-[#35a89d] text-white h-screen p-4 flex flex-col">
      <div>
        <h2 className="text-2xl font-bold mb-8">Admin Panel</h2>
        <ul>
          <li>
            <button onClick={() => setIsFormsOpen(!isFormsOpen)} className="w-full text-left block py-2 px-4 rounded hover:bg-gray-700 text-lg font-bold">
              Forms
            </button>
            {isFormsOpen && (
              <ul className="pl-4">
                <li>
                  <NavLink to="/admin/contacts" className="block py-2 px-4 rounded hover:bg-gray-700">Contacts</NavLink>
                </li>
                <li>
                  <NavLink to="/admin/quotes" className="block py-2 px-4 rounded hover:bg-gray-700">Quotes</NavLink>
                </li>
              </ul>
            )}
          </li>
          <li>
            <button onClick={() => setIsContentOpen(!isContentOpen)} className="w-full text-left block py-2 px-4 rounded hover:bg-gray-700 text-lg font-bold">
              Content
            </button>
            {isContentOpen && (
              <ul className="pl-4">
                <li>
                  <NavLink to="/admin/blogs" className="block py-2 px-4 rounded hover:bg-gray-700">Blogs</NavLink>
                </li>
                <li>
                  <NavLink to="/admin/news" className="block py-2 px-4 rounded hover:bg-gray-700">News</NavLink>
                </li>
                <li>
                  <NavLink to="/admin/events" className="block py-2 px-4 rounded hover:bg-gray-700">Events</NavLink>
                </li>
              </ul>
            )}
          </li>
        </ul>
      </div>
      <div className="mt-auto">
        <button onClick={handleLogout} className="w-full text-left block py-2 px-4 rounded hover:bg-gray-700 text-lg font-bold">
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;